<template>
  <div class="aggregates-information">
    <p class="text-xs font-bold tracking-wider">{{details.aggregate_name}}</p>
    <p class="text-3xl ">{{numberFormat(details.total, '0,0')}}</p>
    <p class="text-xs text-gray-500 tracking-wider">
      <span class="text-green-300">
        <i class="el-icon-caret-bottom"></i>
<!--        {{details.change}}-->
        5%
      </span>
      Last Month
    </p>
  </div>
</template>

<script>
export default {
  name: 'aggregates_info',
  props: {
    details: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
.aggregates-information {
  flex: 0 1 64%
}
</style>
